import { Markdown2Svg } from '@components/Markdown2Svg';

export const FullScreenMindTreeModal = (props) => {
    const {txt,fileName,setFileName,setMdTxt} = props;
    
    return (
        <dialog id="my_fullscreen_mindtree_modal" className="modal">
            <div className="flex flex-col modal-box p-0 realtive w-[90vw] h-[90vh] max-w-[90vw]">
                <div className="bg-white p-4 sticky top-0 z-10">
                    <div className="flex space-between items-center">
                        {fileName && <h2 className="card-title pl-4 mr-6">【文章脉络】- {fileName}</h2>}
                        <form method="dialog">
                            <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 m-1">✕</button>
                        </form>
                    </div>
                </div>

                <div className="flex-1 overflow-auto p-2 lg:px-8 lg:py-2 text-justify">
                    <Markdown2Svg
                        txt={txt}
                        fullScreenDisable
                        setFileName={setFileName}
                        fileName={fileName}
                        setMdTxt={setMdTxt}
                        divHeight="calc(90vh - 120px)"  // 减去头部高度和padding
                    />
                </div>
            </div>
            <form method="dialog" className="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
    )
}